import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Image } from './Utilities'

import AC1x from '../assets/images/about-us/august-1x.png'
import AC2x from '../assets/images/about-us/august-2x.png'
import OED1x from '../assets/images/about-us/oed-1x.png'
import OED2x from '../assets/images/about-us/oed-2x.png'
import KKr1x from '../assets/images/about-us/kkr-1x.png'
import KKr2x from '../assets/images/about-us/kkr-2x.png'
import GA1x from '../assets/images/about-us/ga-1x.png'
import GA2x from '../assets/images/about-us/ga-2x.png'
import Victory1x from '../assets/images/about-us/victory-1x.png'
import Victory2x from '../assets/images/about-us/victory-2x.png'
import Rre1x from '../assets/images/about-us/rre-1x.png'
import Rre2x from '../assets/images/about-us/rre-2x.png'
import Dfj1x from '../assets/images/about-us/dfj-1x.png'
import Dfj2x from '../assets/images/about-us/dfj-2x.png'
import Tiger1x from '../assets/images/about-us/tiger-1x.png'
import Tiger2x from '../assets/images/about-us/tiger-2x.png'

const historyLogos = [
  { img: [AC1x, AC2x, 'August Capital logo'] },
  { img: [OED1x, OED2x, 'OED Investors logo'] },
  { img: [KKr1x, KKr2x, 'KKR logo'] },
  { img: [Rre1x, Rre2x, 'RRE Ventures logo'] },
  { img: [Dfj1x, Dfj2x, 'DFL logo'] },
  { img: [Tiger1x, Tiger2x, 'Tiger Global logo'] },
  { img: [GA1x, GA2x, 'General Atlantic logo'] },
  { img: [Victory1x, Victory2x, 'Victory Park Capital logo'] }
]

function Columns({ customersHelped }) {
  return (
    <section className="history">
      <div className="container__inner">
        <div className="history__content-box">
          <div className="history__text-box">
            <h3 className="history__heading">How it all began.</h3>
            <div className="history__text">
              A byproduct of the Y Combinator startup program accelerator, AvantCredit
              <sup>®</sup> was founded in 2012 with the goal to improve the borrowing experience for
              middle-income consumers. The AvantCredit name quickly became synonymous with
              responsible consumer lending services, a reputation that continues to this day.
            </div>

            <div className="history__text">
              Avant has since streamlined the online borrowing process and helped over{' '}
              {customersHelped} people get the funding they deserve. Avant is backed by some of the
              most well-regarded investors in the fintech space.
            </div>

            <div className="history__button-box">
              <Link className="button--secondary" to="/press/" data-event="press">
                Visit the Press Page
              </Link>
            </div>
          </div>

          <div className="history__list-box">
            <h3 className="history__title">Our Investors</h3>

            <div className="history__logos">
              {historyLogos.map(logo => (
                <span className="history__logo" key={logo.img[2]}>
                  <Image className="history__img" imageArr={logo.img} />
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

Columns.propTypes = {
  customersHelped: PropTypes.string.isRequired
}

export default Columns
